import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import classnames from "classnames";
import { Box } from "../../Box/index.js";
import { CircularProgress } from "../../CircularProgress/index.js";
import { Label } from "../common/index.js";
import { Typography } from "../../Typography/index.js";
import { useStyles } from "./ChipsInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ChipsInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ChipsInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const ChipsInput = (t0)=>{
    const $ = c(71);
    let chipLabelWidth;
    let error;
    let helperText;
    let items;
    let label;
    let labelIcon;
    let onChange;
    let onClick;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let testId;
    let value;
    if ($[0] !== t0) {
        ({ label, labelIcon, items, value, onChange, onClick, required: t1, error, helperText, disabled: t2, loading: t3, tooltip: t4, size: t5, direction: t6, activeSingleOption: t7, testId, variant: t8, chipLabelWidth } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "items",
            "value",
            "onChange",
            "onClick",
            "required",
            "error",
            "helperText",
            "disabled",
            "loading",
            "tooltip",
            "size",
            "direction",
            "activeSingleOption",
            "testId",
            "variant",
            "chipLabelWidth"
        ]);
        $[0] = t0;
        $[1] = chipLabelWidth;
        $[2] = error;
        $[3] = helperText;
        $[4] = items;
        $[5] = label;
        $[6] = labelIcon;
        $[7] = onChange;
        $[8] = onClick;
        $[9] = rest;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
        $[18] = testId;
        $[19] = value;
    } else {
        chipLabelWidth = $[1];
        error = $[2];
        helperText = $[3];
        items = $[4];
        label = $[5];
        labelIcon = $[6];
        onChange = $[7];
        onClick = $[8];
        rest = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        t7 = $[16];
        t8 = $[17];
        testId = $[18];
        value = $[19];
    }
    const required = void 0 === t1 ? false : t1;
    const disabled = void 0 === t2 ? false : t2;
    const loading = void 0 === t3 ? false : t3;
    const tooltip = void 0 === t4 ? null : t4;
    const size = void 0 === t5 ? "large" : t5;
    const direction = void 0 === t6 ? "row" : t6;
    const activeSingleOption = void 0 === t7 ? true : t7;
    const variant = void 0 === t8 ? "default" : t8;
    const { classes } = useStyles();
    let t9;
    if ($[20] !== onChange) {
        t9 = (t10)=>{
            const { target: t11 } = t10;
            const { value: inputValue } = t11;
            null == onChange || onChange(inputValue);
        };
        $[20] = onChange;
        $[21] = t9;
    } else t9 = $[21];
    const handleChange = t9;
    let t10;
    if ($[22] !== onClick) {
        t10 = (e)=>{
            null == onClick || onClick(e);
        };
        $[22] = onClick;
        $[23] = t10;
    } else t10 = $[23];
    const handleClick = t10;
    let t11;
    if ($[24] !== label || $[25] !== labelIcon || $[26] !== required || $[27] !== tooltip) {
        t11 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            className: "aqa_chips_input_label",
            required: required,
            tooltip: tooltip,
            icon: labelIcon
        });
        $[24] = label;
        $[25] = labelIcon;
        $[26] = required;
        $[27] = tooltip;
        $[28] = t11;
    } else t11 = $[28];
    const t12 = "row" === direction;
    let t13;
    if ($[29] !== handleChange) {
        t13 = (event)=>{
            handleChange(event);
        };
        $[29] = handleChange;
        $[30] = t13;
    } else t13 = $[30];
    const t14 = `${classes.row} aqa_chip_button`;
    let t15;
    if ($[31] !== activeSingleOption || $[32] !== chipLabelWidth || $[33] !== classes || $[34] !== disabled || $[35] !== error || $[36] !== handleClick || $[37] !== items || $[38] !== loading || $[39] !== rest || $[40] !== size || $[41] !== value || $[42] !== variant) {
        let t16;
        if ($[44] !== activeSingleOption || $[45] !== chipLabelWidth || $[46] !== classes || $[47] !== disabled || $[48] !== error || $[49] !== handleClick || $[50] !== items.length || $[51] !== loading || $[52] !== rest || $[53] !== size || $[54] !== value || $[55] !== variant) {
            t16 = (t17)=>{
                const { label: itemLabel, value: itemValue, counter, color, icon } = t17;
                const active = itemValue === value || activeSingleOption && 1 === items.length;
                return /*#__PURE__*/ jsx(Box, {
                    children: /*#__PURE__*/ jsx(FormControlLabel, {
                        value: itemValue,
                        className: classes.label,
                        disabled: disabled,
                        control: /*#__PURE__*/ jsx(Radio, {
                            className: classes.radio
                        }),
                        label: /*#__PURE__*/ jsx(Chip, _object_spread_props(_object_spread({}, rest), {
                            onClick: handleClick,
                            label: loading ? /*#__PURE__*/ jsx(CircularProgress, {
                                size: 20,
                                color: itemValue === value ? "primary" : "inherit"
                            }) : /*#__PURE__*/ jsxs(Box, {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8",
                                width: chipLabelWidth,
                                ml: icon && itemLabel ? "2" : "0",
                                children: [
                                    /*#__PURE__*/ jsx(Typography, {
                                        variant: "inherit",
                                        color: "inherit",
                                        noWrap: true,
                                        children: itemLabel
                                    }),
                                    !!counter && /*#__PURE__*/ jsx(Box, {
                                        className: classes.counter,
                                        children: counter
                                    })
                                ]
                            }),
                            variant: "outlined",
                            disabled: disabled,
                            clickable: !disabled,
                            icon: !loading && icon ? /*#__PURE__*/ jsx(Box, {
                                children: icon
                            }) : void 0,
                            className: classnames(classes.chip, classes[size], active && classes.active, !active && "outlined" === variant && classes.outlined, error && classes.error, !active && "outlined" === variant && classes.outlined, disabled && classes.disabled, active && disabled && classes.activeDisabled, color && classes[color])
                        }))
                    }, itemValue)
                }, itemValue);
            };
            $[44] = activeSingleOption;
            $[45] = chipLabelWidth;
            $[46] = classes;
            $[47] = disabled;
            $[48] = error;
            $[49] = handleClick;
            $[50] = items.length;
            $[51] = loading;
            $[52] = rest;
            $[53] = size;
            $[54] = value;
            $[55] = variant;
            $[56] = t16;
        } else t16 = $[56];
        t15 = items.map(t16);
        $[31] = activeSingleOption;
        $[32] = chipLabelWidth;
        $[33] = classes;
        $[34] = disabled;
        $[35] = error;
        $[36] = handleClick;
        $[37] = items;
        $[38] = loading;
        $[39] = rest;
        $[40] = size;
        $[41] = value;
        $[42] = variant;
        $[43] = t15;
    } else t15 = $[43];
    let t16;
    if ($[57] !== t12 || $[58] !== t13 || $[59] !== t14 || $[60] !== t15 || $[61] !== testId || $[62] !== value) {
        t16 = /*#__PURE__*/ jsx(RadioGroup, {
            row: t12,
            "data-testid": testId,
            value: value,
            onChange: t13,
            className: t14,
            children: t15
        });
        $[57] = t12;
        $[58] = t13;
        $[59] = t14;
        $[60] = t15;
        $[61] = testId;
        $[62] = value;
        $[63] = t16;
    } else t16 = $[63];
    let t17;
    if ($[64] !== error || $[65] !== helperText) {
        t17 = error && /*#__PURE__*/ jsx(Box, {
            mt: "4",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "accent.text.error",
                children: helperText
            })
        });
        $[64] = error;
        $[65] = helperText;
        $[66] = t17;
    } else t17 = $[66];
    let t18;
    if ($[67] !== t11 || $[68] !== t16 || $[69] !== t17) {
        t18 = /*#__PURE__*/ jsxs(FormControl, {
            className: "aqa_chips_input",
            component: "fieldset",
            children: [
                t11,
                t16,
                t17
            ]
        });
        $[67] = t11;
        $[68] = t16;
        $[69] = t17;
        $[70] = t18;
    } else t18 = $[70];
    return t18;
};
export { ChipsInput };
